import ResumeItem from "@/common/components/ResumeItem";
import Rows from "@/common/components/Table/rows";
import { branchesEquipmentsConsumptionsTotalizerColumns } from "@/features/movementsTotalizer/constants/branchesEquipmentsConsumptionsTotalizerColumns.constant";
import { ParsedBranchesEquipmentsConsumptionsTotalizerData } from "@/features/movementsTotalizer/types/branchesEquipmentsConsumptionsTotalizer.type";
import { CarFrontIcon } from "lucide-react";

interface EquipmentRowProps {
  equipment: ParsedBranchesEquipmentsConsumptionsTotalizerData['equipments'][number];
}

const EquipmentRow = ({
  equipment,
}: EquipmentRowProps) => {
  return (
    <>
      <tr>
        <td colSpan={branchesEquipmentsConsumptionsTotalizerColumns.length} className="p-0 print:border-x print:border-neutral-200">
          <div className="flex items-center justify-between gap-8 p-3 bg-white-200/15 print:bg-neutral-200">
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-3">
                <CarFrontIcon strokeWidth={1.5} size={22} className="text-blue-800 print:text-black" />

                <ResumeItem
                  label="Equipamento"
                  value={equipment.identifier}
                  className="print:font-medium"
                  labelClassName="text-xs print:text-black"
                  valueClassName="text-sm print:text-black"
                />
              </div>

              <ResumeItem
                label="Modelo"
                value={equipment.modelDisplayName}
                className="print:font-medium"
                labelClassName="text-xs print:text-black"
                valueClassName="text-sm print:text-black"
              />

              <ResumeItem
                label="Ano"
                value={equipment.modelYear}
                className="print:font-medium"
                labelClassName="text-xs print:text-black"
                valueClassName="text-sm print:text-black"
              />
            </div>
          </div>
        </td>
      </tr>

      <Rows
        className="text-sm print:border-b"
        columnClassName="bg-white-100 first:border-l-0 last:border-r-0 print:first:border-l print:last:border-r print:border-neutral-200"
        data={equipment.products}
        columns={branchesEquipmentsConsumptionsTotalizerColumns}
        isLoading={false}
        loadingRows={0}
        showEmptyTable={false}
        emptyValue="--"
        EmptyTable={(
          <div className="py-4 bg-blue-100/5 p-0 flex items-center justify-center print:border-x print:border-neutral-200">
            <p className="italic text-white-400 print:text-black">
              Não possui nenhum registro para esse equipamento
            </p>
          </div>
        )}
      />

      <tr>
        <td colSpan={branchesEquipmentsConsumptionsTotalizerColumns.length} className="p-0 print:border-x print:border-neutral-200">
          <div className="flex items-center justify-between gap-8 p-3 bg-white-200/10 print:bg-neutral-200/50 print:font-medium">
            <p className="">
              Valor total do equipamento
            </p>

            <p>
              {equipment.totalAmount}
            </p>
          </div>
        </td>
      </tr>
    </>
  );
}

export default EquipmentRow;
